'use client';
import React from 'react';

import { VideoType } from '@/api/services/GlobalService/types';
import Image from '@/components/core/Image';
import YouTubePlayer from '@/components/core/YouTubePlayer';
import { useDeviceSize } from '@/hooks/useDeviceSize';
import { useSlide } from '@/hooks/useSlide';
import { useTranslation } from '@/hooks/useTranslations';

const VideoElement = ({
  youtubeVideoId,
  thumbnail,
}: {
  youtubeVideoId: string;
  thumbnail: string;
}) => {
  const [isOpened, setIsOpened] = React.useState(false);

  const handleOpen = () => {
    setIsOpened(true);
  };

  return (
    <div className="ricoMoviesSliderItemHolder">
      <div className="ricoMoviesSliderItemInner">
        {!isOpened && (
          <div className="ricoMoviesImgBlock" onClick={handleOpen}>
            <Image className="ricoMoviesImg" src={thumbnail} alt="" width={234} height={416} />
            <div className="ricoMoviesPlayBlock">
              <i className="bc-i-play ricoMoviesPlayIcon" />
            </div>
          </div>
        )}
        <YouTubePlayer
          videoId={youtubeVideoId}
          autoplay={false}
          width={'100%'}
          height={'100%'}
          isOpened={isOpened}
        />
      </div>
    </div>
  );
};

export default function RicoMoviesSlider({ videos }: { videos: VideoType[] }) {
  const { onSlideLeft, onSlideRight } = useSlide({
    blockClassName: 'ricoMoviesSliderItemHolder',
    containerId: 'rico-movies-slider',
  });
  const { t } = useTranslation();
  const { isMobile } = useDeviceSize();

  if (!videos.length) {
    return null;
  }

  const isArrowsVisible = videos.length > (isMobile ? 1 : 4);

  return (
    <div className="ricoMoviesWrapper">
      <div className="mediumContent">
        <div className="ricoMoviesSliderBlock">
          <div className="ricoMoviesSliderHeader">
            <p className="ricoMoviesSliderTitle">{t('rico-movies')}</p>
            {isArrowsVisible && (
              <div className="ricoMoviesSliderArrow">
                <div className="ricoMoviesSliderItem" onClick={onSlideLeft}>
                  <i className="bc-i-arrow-left"></i>
                </div>
                <div className="ricoMoviesSliderItem" onClick={onSlideRight}>
                  <i className="bc-i-arrow-right"></i>
                </div>
              </div>
            )}
          </div>
          <div className="ricoMoviesSliderContent" id="rico-movies-slider">
            {videos.map(({ youtubeVideoId, thumbnail }, index) => (
              <VideoElement youtubeVideoId={youtubeVideoId} key={index} thumbnail={thumbnail} />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
